
import styles from './PracticalInfo.module.scss'
import Practical from "@/types/Practical";
import moment from "moment";


export default function PracticalInfo(practical: Practical) {

  const condolenceDate = moment(`${practical.condolence_date } ${practical.condolence_time_end ?? practical.condolence_time_start ?? '24:00'}`);
  const funeralDate = moment(`${practical.funeral_date } ${practical.funeral_time_end ?? practical.funeral_time_start ?? '24:00'}`);

  const condolencePast = condolenceDate.isBefore();
  const funeralPast = funeralDate.isBefore();
  return <div className={styles.container}>

    {practical.condolence_date && <div>
      <h3>Condoleance</h3>
      {condolencePast ? "De condoleance heeft reeds plaatsgevonden." : <>
      <div className={styles.content}>
        <dl>
          <dt>Datum</dt>
          <dd>{practical.condolence_date}</dd>
          {practical.condolence_time_start && <>
              <dt>Tijdstip</dt>
              <dd>{practical.condolence_time_start}{practical.condolence_time_end && ` - ${practical.condolence_time_end}`}</dd>
            </>
          }
          {practical.condolence_location && <>
              <dt>Locatie</dt>
              <dd>{practical.condolence_location}</dd>
            </>
          }
          {practical.condolence_parking && <>
              <dt>Parkeren</dt>
              <dd>{practical.condolence_parking}</dd>
            </>
          }
        </dl>
      </div>
      {practical.condolence_location && <a
        target="_blank"
        href={`https://www.google.com/maps/search/?api=1&query=${practical.condolence_location}`}
        className="button button--outline"
      >
        Routeomschrijving OV/Auto
      </a>}
      </>}
    </div>}


    {practical.funeral_date && <div>
      <h3>Uitvaartplechtigheid</h3>
      {funeralPast ? "De uitvaart heeft reeds plaatsgevonden." : <>
        <div className={styles.content}>
          <dl>
            {practical.funeral_date && (<>
                <dt>Datum</dt>
                <dd>{practical.funeral_date}</dd>
              </>
            )}
            {practical.funeral_time_start && (<>
                <dt>Tijdstip</dt>
                <dd>{practical.funeral_time_start}{practical.funeral_time_end && ` - ${practical.funeral_time_end}`}</dd>
              </>
            )}
            {practical.funeral_location && (<>
                <dt>Locatie</dt>
                <dd>{practical.funeral_location}</dd>
              </>
            )}
            {practical.funeral_parking && (<>
                <dt>Parkeren</dt>
                <dd>{practical.funeral_parking}</dd>
              </>
            )}
          </dl>
        </div>
        {practical.funeral_location && <a
          target="_blank"
          href={`https://www.google.com/maps/search/?api=1&query=${practical.funeral_location}`}
          className="button button--outline"
        >
          Routeomschrijving OV/Auto
        </a>}
      </>}
    </div>}


    {practical.funeral_livestream_url && <div>
      <h3>Livestream</h3>
      <div className={styles.content}>
        <p>{practical.funeral_livestream_description}</p>
      </div>
      <a href={practical.funeral_livestream_url} className={'btn btn-secondary'}>Bekijk livestream</a>
    </div>}


    {practical.funeral_last_wish && <div>
      <h3>Laatste wens</h3>
      <div className={styles.content}>
        <p>{practical.funeral_last_wish}</p>
      </div>
      {practical.funeral_donate_url && <a href={practical.funeral_donate_url} className={'btn btn-secondary'}>Doneer</a>}
    </div>}


  </div>
}
